/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1LockIcon24Solid = forwardRef('People1LockIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
        React.createElement("path", { d: "M12 14c.94 0 2.153.04 3.408.268a4.974 4.974 0 0 0-.404 1.789A1.4 1.4 0 0 0 14 17.4V22H4c-1.105 0-2.03-.906-1.821-1.99C3.264 14.394 9.015 14 12 14Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 17.058v-.808a3 3 0 1 1 6 0v.808a1.4 1.4 0 0 1 1 1.342v3.2a1.4 1.4 0 0 1-1.4 1.4h-5.2a1.4 1.4 0 0 1-1.4-1.4v-3.2a1.4 1.4 0 0 1 1-1.342ZM21.5 17h-3v-.75a1.5 1.5 0 0 1 3 0V17Z" })));
});
